var React = require('react');

function CaseCardTopRightDecorator (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M86.3283 75.2339C73.427 32.3571 23.7296 7.14462 0.331055 0.504395H77.6141C82.6 0.504395 86.6357 4.55772 86.614 9.54353L86.3283 75.2339Z","fill":"#18181B"}));
}

CaseCardTopRightDecorator.defaultProps = {"width":"87","height":"76","viewBox":"0 0 87 76","fill":"none"};

module.exports = CaseCardTopRightDecorator;

CaseCardTopRightDecorator.default = CaseCardTopRightDecorator;
